/** Должны быть идентичны бэкенду app/Models/Invoice.php */
export const PAYMENT_STATUS_WAITING_FOR_PAYMENT = 0;
export const PAYMENT_STATUS_SUCCESS = 1;
export const PAYMENT_STATUS_FAILURE = 2;
